// Icons
import infoIcon from "../assets/icons/info-black.svg";

// Config
import useTranslate from "./useTranslate";

export const dialogProps = {
  provideDetails: {
    texts: [
      {
        key: 2,
        text: "caseDetailPage.provideDetails.part2"
      }
    ],
    title: "caseDetailPage.provideDetails.title",
    button: "caseDetailPage.provideDetails.button",
    icon: infoIcon
  }
};

const useDialog = () => {
  const getText = useTranslate();

  const parseTextArray = a =>
    a.map(({ text, ...item }) => ({
      ...item,
      text: getText(text)
    }));

  const getDialogProps = (data, functions) => {
    const onConfirm = functions.provideDetails;
    const currentProps = dialogProps.provideDetails;

    const modalProps = {
      ...currentProps,
      title: getText(currentProps.title),
      button: getText(currentProps.button)
    };

    if (modalProps.texts) modalProps.texts = parseTextArray(modalProps.texts);

    return {
      dialog: {
        ...modalProps,
        type: "submit",
        cancel: getText("common.valueLabels.back")
      },
      onConfirm
    };
  };

  return getDialogProps;
};

export default useDialog;
